console.log(
	"%c Mkey%cMedia",
	"font-weight: bold; font-size: 30px; color: #000; display: inline-block; background-color: red; text-align: right; padding: 10px 5px 10px",
	"font-weight: bold; font-size: 30px; color: #000; display: inline-block; text-align: center; padding: 10px 1px;"
);

gsap.registerPlugin(ScrollTrigger);

// main btn hover
const customHoverBtns = document.querySelectorAll(".mk-hover-btn");
if (customHoverBtns.length) {
	customHoverBtns.forEach((btn) => {
		if (btn) {
			const btnOverlay = btn.querySelector(".mk-btn-overlay");
          
			btn.addEventListener("mouseenter", () => {
				gsap.to(btnOverlay, {
					y: "-50%",
				});
			});
			btn.addEventListener("mouseleave", () => {
				gsap.to(btnOverlay, {
					y: "-125%",
					ease: "power3.out",
					onComplete: () => {
						gsap.set(btnOverlay, {
							y: "100%",
						});
					},
				});
			});
		}
	});
}


// landing hero square animation
const hoverSquareArea = document.querySelector(".hero__square-wrap");
const hoverSquare = document.querySelector(".hero__square");
if (hoverSquareArea && hoverSquare) {
	hoverSquareArea.addEventListener("mousemove", (e) => {
		const { x, y, height, width } = hoverSquareArea.getBoundingClientRect();

		const clientX = e.clientX;
		const clientY = e.clientY;

		const heightMid = y + height / 2;
		const widthMid = x + width / 2;

		let xVal = 0;
		let yVal = 0;
		const distX = widthMid - x;
		const distY = heightMid - y;
		const distClientY = Math.abs(heightMid - clientY);
		const distClientX = Math.abs(widthMid - clientX);

		const resX = (distClientX / distX).toFixed(2);
		const resY = (distClientY / distY).toFixed(2);

		xVal = Number(resX) * 2;
		yVal = Number(resY) * 2;

		if (clientX < widthMid && clientY < heightMid) {
			xVal = -xVal;
		} else if (clientX > widthMid && clientY > heightMid) {
			yVal = -yVal;
		} else if (clientX < widthMid && clientY > heightMid) {
			xVal = -xVal;
			yVal = -yVal;
		}
		gsap.to(hoverSquare, {
			rotationX: yVal * 6,
			rotationY: xVal * 6,
		});
	});

	hoverSquareArea.addEventListener("mouseleave", (e) => {
		gsap.to(hoverSquare, {
			rotationX: 0,
			rotationY: 0,
		});
	});
}


// banners animations
const mkBanners = document.querySelectorAll(".mk-banners__block");
if (mkBanners.length) {
	mkBanners.forEach((el, ind) => {
		const link = el.querySelector(".mk-banners__block-link");
		const linkLine1 = el.querySelector(".mk-banners__block-line.line1");
		const linkLine2 = el.querySelector(".mk-banners__block-line.line2");

		if (link) {
			const tl = gsap.timeline({ paused: true });
			tl.to(linkLine1, {
				clipPath: "polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)",
				duration: 0.4,
				ease: "power3.out",
			});
			tl.to(
				linkLine2,
				{
					clipPath: "polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)",
					delay: 0.2,
					duration: 0.4,
					ease: "power3.out",
				},
				"<"
			);

			link.addEventListener("mouseenter", () => {
				tl.play();
			});
			link.addEventListener("mouseleave", () => {
				tl.reverse();
			});
		}
	});
}


// form animation
const formAnimation = () => {
  const rectsSvg = document.querySelector(".mk-cf__rects-eff");
  if (rectsSvg) {
  	const rects = rectsSvg.querySelectorAll("rect");
  
  	gsap.from(gsap.utils.toArray(rects), {
  		opacity: 0,
  		stagger: 0.2,
  		scrollTrigger: {
  			trigger: ".mk-cf__photo",
  			start: "top 70%",
  			end: "top 30%",
  			scrub: true,
  		},
  	});
  
  	if (rects.length) {
  		rects.forEach((el) => {
  			el.addEventListener("mouseenter", () => {
  				gsap.to(el, {
  					opacity: 0,
  				});
  			});
  			el.addEventListener("mouseleave", () => {
  				setTimeout(() => {
  					gsap.to(el, {
  						opacity: 1,
  					});
  				}, 300);
  			});
  		});
  	}
  }
}

// mk-swiper
const mkSwiper = new Swiper(".mkSwiper", {
	slidesPerView: 1,
	spaceBetween: 10,
	navigation: {
		nextEl: ".mk-slider__btn-next",
		prevEl: ".mk-slider__btn-prev",
	},
});




//tab modul-system

const modul = document.querySelector(".modul-system");

if (modul) {
  const tabBtns = document.querySelectorAll(".modul-system-tab-content");
  const tabContents = document.querySelectorAll(".module-system-right_item");
  tabBtns[0].classList.add("active");
  tabContents[0].classList.add("active");

  tabBtns.forEach((btn, index) => {
    btn.addEventListener("click", () => {
      tabBtns.forEach((elem) => elem.classList.remove("active"));
      btn.classList.add("active");
      tabContents.forEach((elem) => elem.classList.remove("active"));
      tabContents[index].classList.add("active");
    });
  });
}

//tab covers
const covers = document.querySelector(".covers");

if (covers) {
  const tabBtnsCovers = document.querySelectorAll(".covers-bottom_tab");
  const tabContentsCovers = document.querySelectorAll(".covers-center-item");
  tabBtnsCovers[0].classList.add("active");
  tabContentsCovers[0].classList.add("active");
  
  tabBtnsCovers.forEach((btn, index) => {
    btn.addEventListener("click", () => {
      tabBtnsCovers.forEach((elem) => {
        elem.classList.remove("active");
        });
        btn.classList.add("active");
        tabContentsCovers.forEach((elem) => {
        elem.classList.remove("active");
        });
        tabContentsCovers[index].classList.add("active");
    });
  });
}



const initPossibilities = () => {
  const possibilities = document.querySelector(".possibilities");
  if (possibilities) {
    gsap.from(".possibilities-item", {
      opacity: 0,
      stagger: 0.5,
      y:70,
      ease: "power1.inOut",
      duration: 1,
      scrollTrigger: {
        trigger: ".possibilities",
        start: "top 90%",
        end: "top 20%",
        scrub: 1,
      },
    });
  }
  
  const upholstery = document.querySelector(".upholstery");
  if (upholstery) {
    gsap.from(".upholstery-item", {
      opacity: 0,
      rotationY: 90,
      transformOrigin: "center",
      duration: 1.5,
      ease: "power2.out",
      stagger: 0.2,
      scrollTrigger: {
        trigger: ".upholstery",
        start: "top 90%",
        end: "top 50%",
      }
    });
  }
}


/**
 *  gallery block slider
 */
if (document.querySelector(".gallery")) {
  const galleryItems = Array.from(document.querySelectorAll(".gallery__item"));
  const centerIndex = 4;

  const contents = document.querySelectorAll(".gallery__content");

  contents[0].classList.add("active");

  // Добавляем data-index каждому изображению — исходная позиция
  galleryItems.forEach((item, index) => {
    item.querySelector("img").dataset.index = index;
  });

  // Массив исходных src
  let imageSources = galleryItems.map((item) => item.querySelector("img").src);
  let imageIndices = galleryItems.map(
    (item) => item.querySelector("img").dataset.index
  );

  galleryItems.forEach((item, clickedIndex) => {
    item.addEventListener("click", () => {
      const shift = clickedIndex - centerIndex;

      const reorderedSources = [...imageSources];
      const reorderedIndices = [...imageIndices];

      if (shift > 0) {
        reorderedSources.push(...reorderedSources.splice(0, shift));
        reorderedIndices.push(...reorderedIndices.splice(0, shift));
      } else if (shift < 0) {
        reorderedSources.unshift(...reorderedSources.splice(shift));
        reorderedIndices.unshift(...reorderedIndices.splice(shift));
      }

      // 1. Анимация скрытия
      galleryItems.forEach((item) => {
        item.querySelector("img").classList.add("fade-out");
      });

      setTimeout(() => {
        galleryItems.forEach((item, i) => {
          const img = item.querySelector("img");
          img.src = reorderedSources[i];
          img.dataset.index = reorderedIndices[i];
          img.classList.remove("fade-out");
        });

        // Обновляем массивы
        imageSources = reorderedSources;
        imageIndices = reorderedIndices;
      }, 100);

      // 2. Подсветка связанного блока текста
      const clickedImg = item.querySelector("img");
      const realIndex = clickedImg.dataset.index;

      contents.forEach((content, i) => {
        content.classList.toggle("active", i == realIndex);
      });
    });
  });
}









// mk-inst



window.addEventListener("load", () => {
    const svgWrap = document.querySelector(".mk-inst__svg-wrap");
    if (svgWrap && window.innerWidth > 1064) {
    	let instTl = gsap.timeline({
    		scrollTrigger: {
    			trigger: ".mk-inst",
    			start: "top 90%",
    			end: "bottom 20%",
    			scrub: true,
    		},
    	});
    
    	instTl
          .fromTo(svgWrap, { opacity: 0 }, { opacity: 1, duration: 0.5 })
          .to(svgWrap,{ opacity: 1, duration: 3 })
          .to(svgWrap,{ opacity: 0, duration: 0.5 });
    }
    const mkInstImages = document.querySelectorAll(".mk-inst__img");
    if (mkInstImages.length) {
      mkInstImages.forEach((el) => {
          gsap.to(el, {
              clipPath: "inset(0%)",
              duration: 0.125,
              scrollTrigger: {
                  trigger: el,
                  start: "top 85%",
                  toggleActions: "play none none none",
              },
          });
      });
    }

    formAnimation();
    initPossibilities();

  
  	setTimeout(() => {
		verticalSort();
	}, 200);
});




function verticalSort() {
	let scroll = window.scrollY;
	ScrollTrigger.getAll().forEach(
		(t) =>
			(t._sortY = t.trigger
				? scroll + t.trigger.getBoundingClientRect().top
				: t.start + window.innerHeight)
	);
	ScrollTrigger.sort((a, b) => a._sortY - b._sortY);
	ScrollTrigger.refresh();
}

window.addEventListener("resize", verticalSort);
window.addEventListener("load", verticalSort);
document.addEventListener("DOMContentLoaded", verticalSort);
